<template>
  <v-container justify-center pa-3 class="text-center">
    <div class="text-center text-subtitle-1">
      <b>{{ $t('message.no_academy') }}</b>
    </div>
    <div class="text-center mt-2">
      <AcademySelect :label="$t('message.select_academy')" outlined :force-select="true"></AcademySelect>
    </div>
    <v-card-text class="text-center" v-if="!$store.state.inApp">
      <p>{{ $t('message.not_supposed_here') }}</p>
      <div>
        <v-btn color="error" elevation="0" small @click="logout()">
          <v-icon class="mr-1">mdi-logout</v-icon>
          {{ $t("message.logout") }}</v-btn>
      </div>
    </v-card-text>
  </v-container>
</template>
<script>
import AcademySelect from "@/components/inputs/AcademySelect.vue";
import Api from "@/services/Api";

export default {
  created() {
    console.log('Managed academy: ', this.$store.state.managedAcademy);
    console.log('Academy: ', this.$store.state.selectedAcademy);

    //this.$store.dispatch("setSelectedAcademy", null);
    //this.$store.dispatch("setManagedAcademy", null);
    if (this.$store.state.managedAcademy && this.$store.state.user._id) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/admin/" +
          this.$store.state.user._id +
          "/permissions"
        )
        .then((response) => {
          if (response.data.academy && response.data.permissions) {
            this.$store.dispatch("setPermissions", response.data.permissions);
            this.$store.dispatch("setSelectedAcademy", response.data.academy);
            this.navigateTo({
              name: "home"
            });
          } else {
            console.log('No academy or no permissions.')
          }
        });
    } else {
      console.log('Clearing academy and managed academy values')
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
    }
  },
  components: {
    AcademySelect
  },
  methods: {
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", false);
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.$store.dispatch("setStripeAccountId", null);
      localStorage.removeItem("token");
      window.location.replace("/login?to=admin");
    },
  }
}
</script>

<style scoped></style>